import LegalPage from '../components/LegalPage';
import legal from '../legal/legal.json';

export default function PrivacyPage() {
  return <LegalPage doc={legal.privacy} />;
}
